<template>
  <div>
    <breadcrumb :breadcrumbs="breadcrumbs" />
    <header-banner title="お知らせ" />
    <div class="news-contents">
      <div class="news-content" v-for="(item, index) in items" :key="index">
        <div class="news-date">■ {{ item.date }}</div>
        <div class="news-title">
          {{ item.title }}
        </div>
        <!-- <div class="news-body">{{ item.body }}</div> -->
        <span v-html="item.body"></span>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderBanner from '@/components/modules/HeaderBanner'
import Breadcrumb from '@/components/modules/Breadcrumb'
export default {
  components: {
    HeaderBanner,
    Breadcrumb,
  },
  title: 'お知らせ｜B-Call（ビーコール）',
  data() {
    return {
      items: [
        {
          date: '2025-07-12',
          title:
            '「Beyond EC」 新サービスの追加に伴う3シリーズ展開のご案内及び、受信機(BEC-100)の機能向上、付属品追加による価格改定のご案内',
          body: `Androidスマホがそのままレシーバーに！Wi-Fiを利用した「新・呼び出しシステム」！<br />
          「Beyond EC（ビヨンド イーシー）」は新サービスを追加し3シリーズ展開となりました。<br />
          <br />
          又、新サービスの追加・構成変更および受信機(BEC-100)の機能向上・付属品の追加に伴い、<br />
          2025年7月14日 ご発注分より販売価格を改定し適用させて頂きます。<br />
          <br />
          ■3シリーズ製品ラインナップ<br />
          ①Beyond EC（現行品）の機能向上版&emsp;受信機(BEC-100)<br />
          &emsp;モニターやAndroid端末での呼出表示に対応した基本モデルの機能向上版です。<br />
          <br />
          ②Beyond EC for LINE（LINE通知版）  受信機(BEC-100L)<br />
          &emsp;LINE通知に対応したモデルです。お使いのLINEアプリに直接呼出通知を送れます。<br />
          <br />
          ③Beyond EC Connect（VPN通知版）    受信機(BEC-100C)<br />
          &emsp;VPN接続によるインターネット経由で専用アプリ(Android端末)に呼出通知を送れます。<br />
          <br />
          ■機能向上<br />
          ①呼び出し音声の追加<br />
          &emsp;現行13種の呼び出し音に40種の呼び出し音声を追加。<br />
          <br />
          ②受信機(BEC-100)のWi-Fi化<br />
          &emsp;受信機(BEC-100)よりWi-Fi電波を出力。<br />
          <br />
          ③VPN通信の追加(オプション機能)<br />
          &emsp;インターネット回線を利用したVPN通信に対応。<br />
          <br />
          ■付属品の追加<br />
          ①受信機(BEC-100、BEC-100L、BEC-100C) は、HDMIケーブル、LANケーブルを付属品に追加。<br />
          ②外部入力送信機(BEC-231)は、専用アダプターを付属品に追加。<br />
          <br />
          どなたでも簡単操作で安心して使いこなしていただけるシステムです。<br />
          当社通常価格（税別）につきましては、下記の「ご案内ページ」PDFをご覧ください。<br />
          <br />
          ※キャンペーン特別価格や商社様向け特別価格もご用意しておりますので、<br />
          特別価格のお見積りにつきましては、お気軽にお問い合わせください。<br />
          <br />
          <a href="/static/products/beyond-ec/news/news_01.pdf">
            「Beyond EC 新サービスの追加に伴う3シリーズ展開のご案内及び、受信機(BEC-100)の機能向上、付属品追加による価格改定のご案内」
          </a>
          &emsp;※PDF
          <br />
          <a href="/static/products/beyond-ec/news/news_02.pdf">
            「BeyondECシリーズ製品ラインナップと新サービスのご案内」
          </a>
          &emsp;※PDF
          `,
        },
        {
          date: '2024-03-30',
          title: '株式会社ビーアッサ　事務所移転のご案内',
          body: `
          呼び出しベル・チャイム（ワイヤレス）の専門店「ビーコール（B-Call）」の運営会社であります、<br />
          「株式会社ビーアッサ」は事務所移転により、2024年5月1日より、本社及び営業所を移転することになりました。<br />
          つきましては、以下の通り新住所をご案内させて頂きます。<br />
          尚、電話番号・FAX番号・メールアドレスにつきましては変更はございません。<br />
          <br />
          【本社：新住所】<br />
          <span style="padding-left: 20px;">〒922-0101 石川県加賀市山中温泉中田町ハ-101</span><br />
          【営業所：新住所】<br />
          <span style="padding-left: 20px;">〒921-8811 石川県野々市市高橋町10-18</span><br />
          【電話番号：共通】<br />
          <span style="padding-left: 20px;">076-294-4440</span><br />
          【FAX番号：共通】<br />
          <span style="padding-left: 20px;">076-294-4432</span><br />
          【お問合せメールアドレス】<br />
          <span style="padding-left: 20px;"><a href="mailto:info@b-call.jp">
            info@b-call.jp
          </a></span><br />
          <br />
          お客様にご満足いただけるよう、今後もより一層のサービス向上に努めてまいりますので、<br />
          引き続きビーコール（B-Call）を何卒よろしくお願い申し上げます。
          `,
        },
        {
          date: '2023-02-17',
          title:
            '電池レス特定小電力無線とWi-Fiを組み合せた「新・呼び出しシステム」。今春発売予定の新商品「Beyond EC（ビヨンドイーシー）」予約受付け開始のご案内',
          body: `Androidスマホがそのままレシーバーに！Wi-Fiを利用した「新・呼び出しシステム」！<br />
            今春発売予定の新商品「Beyond EC（ビヨンドイーシー）」の予約受付けを開始しました。<br />
            <br />
            Beyond EC は、通信無料の特定小電力無線(920MHz)と、Wi-Fi(無線LAN)を組み合せた呼び出しシステム。<br />
            Wi-Fiを使うので専用のレシーバーは不要。専用アプリをダウンロードすれば、Androidスマホをそのままレシーバーとして利用できます。<br />
            操作は簡単、スワイプ／フリック／タップなど、スマホと同じく直感的に。着信音やバイブレーション設定なども多彩なメニューから選べます。<br />
            <br />
            呼出機は電池レス送信、5つボタンもご用意。ボタンごとに呼び出すグループを指定できます。<br />
            <br />
            受信機は呼出機からの信号を受信し、Wi-Fi(無線LAN)でAndroidスマホに送信します。<br />
            受信機と接続した液晶モニターに呼出し情報を表示することができます。<br />
            <br />
            どなたでも簡単操作で安心して使いこなしていただけるシステムです。<br />
            詳しくは下記の「Beyond EC（ビヨンドイーシー）商品特徴ページ」をご覧ください。<br />
            <br />
            お気軽にお問い合わせください。<br />
            <br />
            <a href="/product/beyond-ec/feature">「Beyond EC（ビヨンドイーシー）商品特徴ページ」</a>
          `,
        },
        {
          date: '2023-02-14',
          title:
            'マウス／タッチパネルの簡単操作！リモートリプライコールPC商品ページ公開のご案内',
          body: `この度、リモートリプライコールPCの商品ページを公開いたしました。<br />
            <br />
            リモートリプライコールをPC画面のマウス／タッチパネルの簡単操作で呼出しが可能な<br />
            リモートリプライコールPCの商品ページを公開いたしました。<br />
            <br />
            登録メッセージをマウスで選択し、受信機番号を入力しコールボタンをクリックするだけ。<br />
            受信機の呼び出し状況は、わかりやすいアイコン表示により、ひと目で確認することができるので、お知らせ漏れの心配がありません。<br />
            <br />
            簡単操作で誰でも安心して使いこなしていただけるシステムです。<br />
            詳しくは下記の「リモートリプライコール商品特徴ページ」をご覧ください。<br />
            <br />
            アプリのカスタマイズにも対応！<br />
            企業さまの既存システムと連携させて、自動送信が可能なPC用アプリのカスタマイズも承っておりますので、お気軽にお問い合わせください。<br />
            <br />
            <a href="/product/remote-reply-call-pc/feature">「リモートリプライコールPC商品特徴ページ」</a>
          `,
        },
        {
          date: '2023-02-14',
          title:
            '複数台送信機システムを実現！リモートリプライコール管理機のご案内',
          body: `長距離通信システム！32文字のメッセージを送信できるリモートリプライコールが、管理機の設置により複数台の送信機から受信機の呼出しが可能になりました。<br />
            <br />
            管理機は送信機と受信機の信号を管理するための機械で、複数台送信機システムには管理機が必ず必要になります。<br />
            管理機は送信機用管理機1台と受信機用管理機1台で1セットとなります。<br />
            <br />
            送信機用管理機は送信機の予約状況等を確認し受信機用管理機に伝えます。<br />
            受信機用管理機は送信機用管理機からのデータを受信機へ送信します。<br />
            <br />
            複数の送信機から同じ受信機の呼出しが可能なシステムです。<br />
            詳しくは下記の「リモートリプライコール商品特徴ページ」をご覧ください。<br />
            <br />
            お気軽にお問い合わせください。<br />
            <br />
            <a href="/product/remote-reply-call/feature">「リモートリプライコール商品特徴ページ」</a>
          `,
        },
        {
          date: '2023-02-07',
          title: 'コココール送信機タマゴ型（CC-E01～E28）販売終了のご案内',
          body: `
          これまで販売を行なってまいりました「コココール送信機タマゴ型（CC-E01～E28）」及び「コココール送信機タマゴ型ナプキン付（CC-E01N～E28N）」につきまして、販売終了のご案内をさせていただきます。<br />
          <br />
          コココール送信機タマゴ型及びコココール送信機タマゴ型ナプキン付につきましては、メーカー生産終了のため、2023年2月をもって弊社での下記商品の販売を終了させていただきます。<br />
          <br />
          ・コココール送信機タマゴ型（CC-E01～E28）<br />
          ・コココール送信機タマゴ型ナプキン付（CC-E01N～E28N）<br />
          <br />
          保守サービス（修理）に関しましては当分の間は対応させて頂きます。<br />
          <br />
          今後、同様の商品をお買い求めのお客様は、高い防水性と耐久性の電池を使用しない<br />
          「<a href="/product/eco-chime/feature">エコチャイム</a>」をお買い求めいただきますようよろしくお願い申し上げます。
          `,
        },
        {
          date: '2020-11-25',
          title: 'フォームお見積り特別価格キャンペーンのご案内',
          body: `ホームページ開設1周年を記念して、<br />
          フォームからお問い合わせ頂いた方を限定に、お見積り特別価格キャンペーンを実施します。<br />
          また、キャンペーン中は価格相談も承ります。<br />
          まずは、<a href="/contact">お問い合わせフォーム</a>からお見積りをご依頼ください。<br />
          <br />
          お気軽にお問い合わせください。
          `,
        },
        {
          date: '2020-10-15',
          title:
            'マウス／タッチパネルの簡単操作で呼出状況を管理！リモートリプライコールＰＣのご案内',
          body: `長距離通信システム！32文字のメッセージを送信できるリモートリプライコールが、PC画面のマウス／タッチパネルの簡単操作で呼出しが可能になりました。<br />
          登録メッセージをマウスで選択し、受信機番号を入力しコールボタンをクリックするだけ。<br />
          受信機の呼び出し状況は、わかりやすいアイコン表示により、ひと目で確認することができるので、お知らせ漏れの心配がありません。<br />
          簡単操作で誰でも安心して使いこなしていただけるシステムです。<br />
          詳しくは下記の「リモートリプライコールＰＣのご案内」ＰＤＦをご覧ください。<br />
          <br />
          お気軽にお問い合わせください。<br />
          <br />
          <a href="/static/products/reply-call-pc/news/news_01.pdf">
            「リモートリプライコールＰＣのご案内」
          </a>
          ※PDF
          `,
        },
        {
          date: '2020-10-01',
          title: '任意の番号表示で簡単呼出し！ファクトインコール10キーのご案内',
          body: `リプライコール＋ファクトインコールの組合せで様々なシーンでの活用が可能です。<br />
          新ソフトの開発により両製品の連携が「ファクトインコール10キー」で可能になりました。<br />
          リプライコールの送信機から表示させたい番号を入力して送信するだけ。<br />
          ファクトインコールの受信表示機や携帯受信表示機に任意の番号を表示することが出来ます。（下記PDF参照。）<br />
          難しい設定は不要ですので、いつでも簡単に導入することが可能です。<br />
          <br />
          このシステムはオプションでの構成となります。詳しくはお問い合わせください。<br />
          <br />
          <a href="/static/products/fact-in-call/news/news_01.pdf">
            「ファクトインコール10キーのご案内」
          </a>
          ※PDF
          `,
        },
        {
          date: '2020-09-01',
          title: '厚生労働省 医療機関・医療従事者支援策のご案内',
          body: `厚生労働省は、「医療機関･薬局等における感染拡大防止等支援事業」として、新型コロナ感染症の院内等での感染拡大を防ぐための取組を行う病院・診療所・薬局・訪問看護ステーション・助産所に対して、感染拡大防止対策や診療体制確保などに要する費用を補助しています。（2020.4.1～2021.3.31までにかかる費用が対象です。）<br />
          <br />
          弊社取り扱い商品は対象となりますので、この機会にぜひご活用して導入をご検討ください。<br />
          詳しくは厚生労働省のホームページをご覧ください。（下記参照。）<br />
          <br />
          <a href="https://www.mhlw.go.jp/stf/seisakunitsuite/bunya/kenkou_iryou/iryou/kansenkakudaiboushi_shien.html">
            厚生労働省ホームページ「医療機関・薬局等における感染拡大防止等の支援」について<br />
          </a>
          <a href="https://www.mhlw.go.jp/content/10800000/000641440.pdf">
            「医療機関・薬局等における感染拡大防止等の支援」<br />
          </a>
          <a href="https://www.mhlw.go.jp/content/000650104.pdf">
            「医療機関･薬局等における感染拡大防止等支援事業」
          </a>
          ※PDF4ページ目
          `,
        },
        {
          date: '2019-12-25',
          title: 'デモ機の無料レンタルを開始しました。',
          body: `デモ機の1週間無料レンタルを開始しました。<br />
          「電波が届くのか心配」「購入前に試してみたい」など、ご購入に不安がある方は<br />
          実際にご使用いただく場所で、商品の動作や使い勝手などを十分にお試しください。<br />
          デモ機は全商品をご用意しました。<br />
          <br />
          お気軽にお問い合わせください。`,
        },
        {
          date: '2019-11-25',
          title: 'B-Call のウェブサイトを公開しました。',
          body: `無線呼び出しチャイム・パーソナルコールシステムの専門店として、<br />
          この度、「ビーコール（B-Call）」のホームページを開設いたしました。<br />
          <br />
          お客様にご満足いただけるよう、今後もよりいっそう充実したウェブサイトにしていきますので、<br />
          今後ともビーコール（B-Call）を何卒よろしくお願い申し上げます。`,
        },
      ],
    }
  },
  computed: {
    breadcrumbs: function() {
      return {
        data: [
          {
            name: '呼び出しベルのB-Call',
            path: 'https://b-call.jp/',
          },
          {
            name: 'お知らせ',
            path: 'https://b-call.jp/news',
          },
        ],
      }
    },
  },
}
</script>

<style scoped>
.news-contents {
  width: 90%;
  max-width: 1100px;
  margin: 0 auto;
}

.news-content {
  margin-bottom: 40px;
}

.news-content .news-date {
  font-weight: bold;

  color: rgb(26, 161, 230);
}

.news-content .news-title {
  font-weight: bold;

  margin: 5px 0 15px;
  padding: 5px 15px;

  color: white;
  background-color: rgb(26, 87, 167);
}

.news-content .news-body {
  white-space: pre-line;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/News.vue